<template>
    <b-form @submit.prevent="getReports(formData)">
        <b-form-group :label="$t('general.iin')">
            <b-form-input v-model="dealerIin" :disabled="dealerIin != null"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('report.createDate')">
            <b-form-select v-model="dateRangeType" :options="dateRangeTypes" v-on:change="dateRangeTypeSelected"></b-form-select>
        </b-form-group>
        <b-form-group :label="$t('general.fromDate')">
            <date-picker v-model="formData.createDateStart" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('general.toDate')">
            <date-picker v-model="formData.createDateEndForm" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" width="100%"></date-picker>
        </b-form-group>
        <b-form-group :label="$t('kkm.label')">
            <multiselect v-model="ccm" 
                :options="kkms" 
                :internal-search="true" 
                :placeholder="$t('general.enterValue')"
                :select-label="''"
                :showNoResults="false"
                label="factoryNumber">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
            </multiselect>
        </b-form-group>
        <b-form-group :label="$t('report.type')">
            <b-form-select :options="reportTypes" v-model="formData.type"></b-form-select>
        </b-form-group>
        <b-form-row class="mx-0">
            <b-button type="submit" variant="success" class="ml-auto" :disabled="isDisabled">
                <magnify-icon title="" />&nbsp;{{ $t('general.search') }}
            </b-button>
        </b-form-row>
    </b-form>
</template>

<script>
/* eslint-disable */
import AppData from '@/utils/appdata';
import { normalizeArrayOfCcm, DateRangeType, getDateRange, getEndOfCurrentDay } from '@/utils/utils';

export default {
    name: 'ReportSearchForm',
    mixins: [ AppData ],
    props: {
        fetch: Function,
        setOffset: Function,
        kkms: Array,
        dealerIin: String,
        pageSize: Number,
        offset: Number
    },
    data () {
        return {
            dateRangeType: DateRangeType.LastDay,
            formData: {
                type: null,
                createDateStart: null,
                createDateEndForm: null,
                createDateEnd: getEndOfCurrentDay(),
                offset: this.offset,
                pageSize: this.pageSize
            },
            ccm: null,
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    mounted() {
        this.dateRangeTypeSelected();
    },
    computed: {
        reportTypes() {
            return [
                { value: null, text: this.$t('general.select') },
                { value: 'Z_REPORT', text: this.$t('report.types.Z_REPORT') },
                { value: 'X_REPORT', text: this.$t('report.types.X_REPORT') },
                { value: 'FISCAL_PERIOD_REPORT', text: this.$t('report.types.FISCAL_PERIOD_REPORT') },
                { value: 'CASHIER_REPORT', text: this.$t('report.types.CASHIER_REPORT') },
                { value: 'SECTION_REPORT', text: this.$t('report.types.SECTION_REPORT') }
            ]
        },
        dateRangeTypes() {
            return [
                { value: DateRangeType.LastHour, text: this.$t('general.lastHour') },
                { value: DateRangeType.Last12Hours, text: this.$t('general.last12Hours') },
                { value: DateRangeType.LastDay, text: this.$t('general.lastDay') }
            ]
        }
    },
    watch: {
        offset(newValue) {
            this.formData.offset = newValue
            this.fetch(this.formData)
        }
    },
    methods: {
        getReports(formData) {
            if (this.offset !== 0) {
                this.setOffset(0)
            } else {
                this.formData['ccm'] = this.ccm != null ? this.ccm.id : null;
                this.fetch(formData);
            }
        },
        dateRangeTypeSelected() {
            const dateRange = getDateRange(this.dateRangeType);

            this.formData.createDateStart = dateRange.start;
            this.formData.createDateEndForm = dateRange.end;
        }
    }
}
</script>
